var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitlab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1673 19.9837L49.0999 19.804L42.2947 2.05264C42.157 1.70409 41.9119 1.40841 41.5949 1.20841C41.3585 1.05702 41.0898 0.963136 40.8105 0.934287C40.5312 0.905437 40.249 0.942426 39.9865 1.04229C39.7241 1.14215 39.4887 1.3021 39.2992 1.50933C39.1097 1.71656 38.9714 1.9653 38.8953 2.23562L34.3018 16.2986H15.6999L11.1063 2.23562C11.0297 1.96571 10.8911 1.71743 10.7015 1.5106C10.5119 1.30377 10.2766 1.1441 10.0144 1.04432C9.75216 0.944538 9.47024 0.907412 9.19112 0.935903C8.91199 0.964393 8.64339 1.05771 8.40672 1.20841C8.08977 1.40841 7.84468 1.70409 7.70694 2.05264L0.904941 19.8072L0.834321 19.9837C-0.144967 22.5431 -0.265612 25.3514 0.490574 27.9854C1.24676 30.6193 2.83878 32.9359 5.02659 34.586L5.05227 34.6053L5.11005 34.6502L15.4623 42.4088L20.5983 46.2897L23.7184 48.6491C24.0845 48.9256 24.5308 49.0752 24.9896 49.0752C25.4484 49.0752 25.8947 48.9256 26.2608 48.6491L29.3809 46.2897L34.5169 42.4088L44.943 34.6053L44.9719 34.5828C47.1596 32.9333 48.7518 30.6174 49.5085 27.9842C50.2653 25.3509 50.1455 22.543 49.1673 19.9837Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlab);
export default __webpack_public_path__ + "static/media/gitlab.59aa55b0367d6f0b6b51bfa2e7514802.svg";
export { ForwardRef as ReactComponent };